import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function PostFranchise() {
  const navigate = useNavigate();
 

  const [formData, setFormData] = useState({
    franchise_type: "new",
    franchise_brand: "",
    territory_name: "",
    territory_type: "exclusive",

    number_of_clients: "",
    total_client_value: "",
    avg_job_price: "",

    starter_clients_available: "0",
    starter_clients_count: "",
    starter_clients_total_value: "",
    starter_clients_avg_job_price: "",

    work_guarantee: "0",
    work_guarantee_amount: "",
    work_guarantee_period: "",

    training_included: "0",
    vehicle_included: "0",
    vehicle_details: "",
    trailer_included: "0",
    trailer_details: "",
    equipment_included: "0",
    equipment_details: "",

    price: "",
    description: "",
    suburb: "",
    state: "",
    postcode: "",

    enquiry_only: "0",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ⭐ NUMERIC FIELDS TO PROTECT
  const numericFields = [
    "price",
    "number_of_clients",
    "total_client_value",
    "avg_job_price",
    "starter_clients_count",
    "starter_clients_total_value",
    "starter_clients_avg_job_price",
    "work_guarantee_amount",
    "postcode",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    // ⭐ allow typing only numbers for numeric fields
    if (numericFields.includes(name)) {
      const filtered = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({ ...prev, [name]: filtered }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMessage("");
  setSuccessMessage("");

  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("userId");

  if (!token) {
    setErrorMessage("Authentication expired. Please log in again.");
    return;
  }

  try {
    // 1️⃣ Create draft franchise listing
    const payload = {
      user_id,
      ...formData,
      badge: "F",
      status: "draft",
    };

    const draftRes = await axios.post(
      `${API_BASE_URL}/api/lawn-mowing/franchises/create`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!draftRes.data.success || !draftRes.data.franchise_id) {
      setErrorMessage("Failed to create draft listing.");
      return;
    }

    const franchiseId = draftRes.data.franchise_id;

    // 2️⃣ Stripe checkout
    const stripeRes = await axios.post(
      `${API_BASE_URL}/api/lawn-mowing/franchises/payment`,
      {
        listing_id: franchiseId,
        listing_type: "franchise",
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!stripeRes.data.url) {
      setErrorMessage("Stripe session failed.");
      return;
    }

    window.location.href = stripeRes.data.url;

  } catch (err) {
    console.error("Franchise post error:", err);
    setErrorMessage("Server error while posting listing.");
  }
};


  /* -----------------------------------
    STYLES (unchanged)
  ----------------------------------- */
  const container = {
    maxWidth: "700px",
    margin: "120px auto 20px",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    zIndex: 1,
    position: "relative",
  };

  const header = {
    color: "#2e7d32",
    fontWeight: "bold",
    fontSize: "1.6rem",
    marginBottom: "20px",
  };

  const sectionHeader = {
    background: "#e8f5e9",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "20px",
    fontWeight: "bold",
    color: "#1b5e20",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const submitButton = {
    width: "100%",
    padding: "14px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    fontSize: "1.2rem",
    fontWeight: "bold",
    borderRadius: "8px",
    marginTop: "25px",
    cursor: "pointer",
  };

  return (
    <div style={container}>
      <div style={header}>Create Lawn Mowing Franchise Listing</div>

      {errorMessage && (
        <p style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</p>
      )}

      {successMessage && (
        <p style={{ color: "green", marginBottom: "10px" }}>{successMessage}</p>
      )}

      <form onSubmit={handleSubmit}>
        {/* Franchise Information */}
        <div style={sectionHeader}>Franchise Information</div>

        <label>Franchise Type</label>
        <select
          name="franchise_type"
          style={inputStyle}
          value={formData.franchise_type}
          onChange={handleChange}
        >
          <option value="new">New Franchise</option>
          <option value="existing">Existing Franchise</option>
        </select>

        <label>Franchise Brand</label>
        <input
          name="franchise_brand"
          style={inputStyle}
          value={formData.franchise_brand}
          onChange={handleChange}
          required
        />

        <label>Territory Name</label>
        <input
          name="territory_name"
          style={inputStyle}
          value={formData.territory_name}
          onChange={handleChange}
          required
        />

        <label>Territory Type</label>
        <select
          name="territory_type"
          value={formData.territory_type}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="exclusive">Exclusive</option>
          <option value="non-exclusive">Non-Exclusive</option>
        </select>

        {/* Existing Franchises */}
        {formData.franchise_type === "existing" && (
          <>
            <div style={sectionHeader}>Existing Franchise Metrics</div>

            <label>Number of Clients</label>
            <input
              type="text"
              name="number_of_clients"
              style={inputStyle}
              value={formData.number_of_clients}
              onChange={handleChange}
            />

            <label>Total Client Value ($)</label>
            <input
              type="text"
              name="total_client_value"
              style={inputStyle}
              value={formData.total_client_value}
              onChange={handleChange}
            />

            <label>Average Job Price ($)</label>
            <input
              type="text"
              name="avg_job_price"
              style={inputStyle}
              value={formData.avg_job_price}
              onChange={handleChange}
            />
          </>
        )}

        {/* Starter Clients (New Franchises) */}
        {formData.franchise_type === "new" && (
          <>
            <div style={sectionHeader}>Starter Client Pack (Optional)</div>

            <label>Starter Client Pack Available?</label>
            <select
              name="starter_clients_available"
              style={inputStyle}
              value={formData.starter_clients_available}
              onChange={handleChange}
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>

            {formData.starter_clients_available === "1" && (
              <>
                <label>Starter Clients Count</label>
                <input
                  type="text"
                  name="starter_clients_count"
                  style={inputStyle}
                  value={formData.starter_clients_count}
                  onChange={handleChange}
                />

                <label>Starter Total Value ($)</label>
                <input
                  type="text"
                  name="starter_clients_total_value"
                  style={inputStyle}
                  value={formData.starter_clients_total_value}
                  onChange={handleChange}
                />

                <label>Starter Average Job Price ($)</label>
                <input
                  type="text"
                  name="starter_clients_avg_job_price"
                  style={inputStyle}
                  value={formData.starter_clients_avg_job_price}
                  onChange={handleChange}
                />
              </>
            )}
          </>
        )}

        {/* Work Guarantee */}
        <div style={sectionHeader}>Work Guarantee</div>

        <label>Work Guarantee Offered?</label>
        <select
          name="work_guarantee"
          value={formData.work_guarantee}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.work_guarantee === "1" && (
          <>
            <label>Guarantee Amount</label>
            <input
              type="text"
              name="work_guarantee_amount"
              style={inputStyle}
              value={formData.work_guarantee_amount}
              onChange={handleChange}
            />

            <label>Guarantee Period</label>
            <input
              name="work_guarantee_period"
              style={inputStyle}
              value={formData.work_guarantee_period}
              onChange={handleChange}
            />
          </>
        )}

        {/* Included Items */}
        <div style={sectionHeader}>Included Items</div>

        <label>Training Included?</label>
        <select
          name="training_included"
          style={inputStyle}
          value={formData.training_included}
          onChange={handleChange}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        <label>Vehicle Included?</label>
        <select
          name="vehicle_included"
          style={inputStyle}
          value={formData.vehicle_included}
          onChange={handleChange}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.vehicle_included === "1" && (
          <>
            <label>Vehicle Details</label>
            <textarea
              name="vehicle_details"
              rows="2"
              style={inputStyle}
              value={formData.vehicle_details}
              onChange={handleChange}
            />
          </>
        )}

        <label>Trailer Included?</label>
        <select
          name="trailer_included"
          style={inputStyle}
          value={formData.trailer_included}
          onChange={handleChange}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.trailer_included === "1" && (
          <>
            <label>Trailer Details</label>
            <textarea
              name="trailer_details"
              rows="2"
              style={inputStyle}
              value={formData.trailer_details}
              onChange={handleChange}
            />
          </>
        )}

        <label>Equipment Included?</label>
        <select
          name="equipment_included"
          style={inputStyle}
          value={formData.equipment_included}
          onChange={handleChange}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.equipment_included === "1" && (
          <>
            <label>Equipment Details</label>
            <textarea
              name="equipment_details"
              rows="2"
              style={inputStyle}
              value={formData.equipment_details}
              onChange={handleChange}
            />
          </>
        )}

        {/* Listing Info */}
        <div style={sectionHeader}>Listing Information</div>

        <label>Price ($)</label>
        <input
          type="text"
          name="price"
          style={inputStyle}
          value={formData.price}
          onChange={handleChange}
          required
        />

        <label>Description</label>
        <textarea
          name="description"
          rows="4"
          style={inputStyle}
          value={formData.description}
          onChange={handleChange}
          required
        />

        <label>Suburb</label>
        <input
          name="suburb"
          style={inputStyle}
          value={formData.suburb}
          onChange={handleChange}
          required
        />

        <label>State</label>
        <select
          name="state"
          style={inputStyle}
          value={formData.state}
          onChange={handleChange}
          required
        >
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label>Postcode</label>
        <input
          type="text"
          name="postcode"
          style={inputStyle}
          value={formData.postcode}
          onChange={handleChange}
        />

    

        {/* Submit */}
        <button type="submit" style={submitButton}>
          Post Franchise Listing
        </button>
      </form>
    </div>
  );
}
